import Theme from 'src/theme/Theme';
import styled from 'styled-components';

export const MainContainer = styled.div`
  overflow-y: scroll;
`;
export const Section = styled.div`
  border-radius: 8px;
  border: 1px solid ${Theme.colors.TABLE_OUTLINE};
  padding: 12px;
  margin: 12px;
  gap: 12px;
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  width: 100%;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  gpa: 8px;
`;

export const ItemTitle = styled.div`
  font-size: 14px;
  color: ${Theme.colors.NEUTRAL_MEDIUM};
`;

export const Title = styled.div`
  font-size: 14px;
  color: ${Theme.colors.NEUTRAL_HIGH};
  font-weight: 800;
`;
export const Text = styled.div`
  font-size: 14px;
`;

export const LoaderContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1; /* Ensures loader is on top of the chart */
`;
